import ApiPlaygroundClassic from "../APIPlayground/ApiPlaygroundClassic";
import React from "react"
import { connect } from "react-redux";
import AiPromptUrl from "./Ai.yaml"; 

function AiUpdate(props) {
    const fileHash = props.fileInformation && Object.keys(props.fileInformation).length > 0 
        ? props.fileInformation[Object.keys(props.fileInformation)[0]].fileHash 
        : null;
    console.log("fileInformation", props.fileInformation);
    console.log("AI", fileHash)
    return (
        <ApiPlaygroundClassic
            specUrl={AiPromptUrl}
            operationId="updateTestSpreadsheet"     // optional; if omitted, first op is chosen
            languages={["curl","python","javascript","ruby","php"]}
            fileInformation={props.fileInformation}
            fileHash={fileHash}
        />
    )
}

const mapStateToProps = (state) => ({
    fileInformation: state.mainState.fileInformation
})

export default connect(mapStateToProps)(AiUpdate)